import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Home } from 'lucide-react';
import { Button } from '../components/ui/button';

const NotFoundPage = () => {
  const { i18n } = useTranslation();

  return (
    <div className="min-h-screen bg-misel-bg flex items-center justify-center p-8">
      <div className="text-center">
        <h1 className="font-roboto font-bold text-8xl text-primary mb-4">404</h1>
        <p className="text-gray-400 text-xl mb-8">
          {i18n.language === 'el' ? 'Η σελίδα δεν βρέθηκε' : 'Page not found'}
        </p>
        <Link to="/">
          <Button className="bg-primary hover:bg-primary/90">
            <Home size={18} className="mr-2" />
            {i18n.language === 'el' ? 'Επιστροφή' : 'Go Home'}
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
